import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export function AuthCard({ title, subtitle, children }: { title: string; subtitle?: string; children: ReactNode }) {
  return (
    <div className="min-h-screen bg-bg flex flex-col">
      {/* Header */}
      <header className="px-6 lg:px-12 py-5 flex items-center justify-between border-b border-border/40">
        <Link to="/" className="flex items-center gap-2">
          <Logo />
          <span className="font-bold text-base tracking-wide">TELOS</span>
        </Link>
      </header>

      {/* Centered card */}
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <motion.div
          initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="w-full max-w-md"
        >
          <div className="bg-bg-card border border-border rounded-2xl p-7 sm:p-9 card-highlight">
            <div className="mb-7 text-center">
              <h1 className="text-xl sm:text-2xl font-bold tracking-tight">{title}</h1>
              {subtitle && <p className="mt-2 text-sm text-fg-muted">{subtitle}</p>}
            </div>
            {children}
          </div>
        </motion.div>
      </main>
    </div>
  );
}

function Logo() {
  return (
    <svg width="22" height="22" viewBox="8 8 60 60" fill="none" className="text-accent">
      <circle cx="38" cy="38" r="30" fill="none" stroke="currentColor" strokeWidth="0.8" opacity="0.3" />
      <circle cx="38" cy="38" r="12" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="38" cy="38" r="4.5" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="38" cy="38" r="1.8" fill="currentColor" />
      <line x1="38" y1="8" x2="38" y2="24" stroke="currentColor" strokeWidth="1.2" />
      <line x1="38" y1="52" x2="38" y2="68" stroke="currentColor" strokeWidth="1.2" />
      <line x1="8" y1="38" x2="24" y2="38" stroke="currentColor" strokeWidth="1.2" />
      <line x1="52" y1="38" x2="68" y2="38" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  );
}
